export const DISTRICT_COURT_DATA = [
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_ALMBK",
    "label": "Alabama Middle Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_ALNBK",
    "label": "Alabama Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_ALSBK",
    "label": "Alabama Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_AKBK",
    "label": "Alaska Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_AZBK",
    "label": "Arizona Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_AREBK",
    "label": "Arkansas Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_ARWBK",
    "label": "Arkansas Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_CACBK",
    "label": "California Central Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_CAEBK",
    "label": "California Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_CANBK",
    "label": "California Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_CASBK",
    "label": "California Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_COBK",
    "label": "Colorado Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_CTBK",
    "label": "Connecticut Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_DEBK",
    "label": "Delaware Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_DCBK",
    "label": "District Of Columbia Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_FLMBK",
    "label": "Florida Middle Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_FLNBK",
    "label": "Florida Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_FLSBK",
    "label": "Florida Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_GAMBK",
    "label": "Georgia Middle Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_GANBK",
    "label": "Georgia Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_GASBK",
    "label": "Georgia Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_GUBK",
    "label": "Guam Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_HIBK",
    "label": "Hawaii Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_IDBK",
    "label": "Idaho Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_ILCBK",
    "label": "Illinois Central Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_ILNBK",
    "label": "Illinois Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_ILSBK",
    "label": "Illinois Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_INNBK",
    "label": "Indiana Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_INSBK",
    "label": "Indiana Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_IANBK",
    "label": "Iowa Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_IASBK",
    "label": "Iowa Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_KSBK",
    "label": "Kansas Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_KYEBK",
    "label": "Kentucky Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_KYWBK",
    "label": "Kentucky Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_LAEBK",
    "label": "Louisiana Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_LAMBK",
    "label": "Louisiana Middle Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_LAWBK",
    "label": "Louisiana Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MEBK",
    "label": "Maine Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MDBK",
    "label": "Maryland Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MABK",
    "label": "Massachusetts Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MIEBK",
    "label": "Michigan Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MIWBK",
    "label": "Michigan Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MNBK",
    "label": "Minnesota Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MSNBK",
    "label": "Mississippi Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MSSBK",
    "label": "Mississippi Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MOEBK",
    "label": "Missouri Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MOWBK",
    "label": "Missouri Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_MTBK",
    "label": "Montana Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NEBK",
    "label": "Nebraska Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NVBK",
    "label": "Nevada Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NHBK",
    "label": "New Hampshire Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NJBK",
    "label": "New Jersey Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NMBK",
    "label": "New Mexico Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NYEBK",
    "label": "New York Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NYNBK",
    "label": "New York Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NYSBK",
    "label": "New York Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NYWBK",
    "label": "New York Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NCEBK",
    "label": "North Carolina Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NCMBK",
    "label": "North Carolina Middle Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NCWBK",
    "label": "North Carolina Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NDBK",
    "label": "North Dakota Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_NMIBK",
    "label": "Northern Mariana Islands Bankruptcy",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_OHNBK",
    "label": "Ohio Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_OHSBK",
    "label": "Ohio Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_OKEBK",
    "label": "Oklahoma Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_OKNBK",
    "label": "Oklahoma Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_OKWBK",
    "label": "Oklahoma Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_ORBK",
    "label": "Oregon Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_PAEBK",
    "label": "Pennsylvania Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_PAMBK",
    "label": "Pennsylvania Middle Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_PAWBK",
    "label": "Pennsylvania Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_PRBK",
    "label": "Puerto Rico Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_RIBK",
    "label": "Rhode Island Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_SCBK",
    "label": "South Carolina Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_SDBK",
    "label": "South Dakota Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_TNEBK",
    "label": "Tennessee Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_TNMBK",
    "label": "Tennessee Middle Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_TNWBK",
    "label": "Tennessee Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_TXEBK",
    "label": "Texas Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_TXNBK",
    "label": "Texas Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_TXSBK",
    "label": "Texas Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_TXWBK",
    "label": "Texas Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_UTBK",
    "label": "Utah Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_VTBK",
    "label": "Vermont Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_VIBK",
    "label": "Virgin Islands Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_VAEBK",
    "label": "Virginia Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_VAWBK",
    "label": "Virginia Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_WAEBK",
    "label": "Washington Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_WAWBK",
    "label": "Washington Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_WVNBK",
    "label": "West Virginia Northern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_WVSBK",
    "label": "West Virginia Southern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_WIEBK",
    "label": "Wisconsin Eastern Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_WIWBK",
    "label": "Wisconsin Western Bankruptcy Court",
  },
  {
    "courtType": "U.S. Bankruptcy Courts",
    "key": "N_WYBK",
    "label": "Wyoming Bankruptcy Court",
  },
];

export function getDistrictNameById(key: string): string {
  return DISTRICT_COURT_DATA.find(item => item.key === key)?.label || '';
}

export function getDistrictIdByName(courtName: string): string | null {
  const court = DISTRICT_COURT_DATA.find(c => c.label === courtName);
  return court ? court.key : null;
}